module.exports = __webpack_public_path__ + "img/ssyx_01.914e74c1.jpg";